import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sourcesFilter',
    standalone: false
})
export class SourcesFilterPipe implements PipeTransform {

  transform(arr: any[], searchText: string, field: string = "name"): any[] {
    if (!arr) return [];
    if (!searchText) return arr;
    searchText = searchText.toLowerCase();
    return arr.filter((item:any) => {
      return item[field].toLowerCase().includes(searchText);
    });
  }

}
